import React from 'react'
import DataSource from '../DataSource'
import Tab from '../components/Tab'
import ExpandableListModule from '../modules/ExpandableListModule'
import BannerNetworkIssue from '../banners/BannerNetworkIssue'
import FaqStructuredData from '../components/FaqStructuredData'

class NbnAboutSpeeds extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            isLoaded: false,
            title: '',
            description: '',
            data: []
        }
    }

    componentDidMount () {
        DataSource.getData('/api/getContent/nbn/speeds', response => {
            this.setState({
                ...response,
                isLoaded: true
            })
        })
    }

    render () {
        return (
            <React.Fragment>
                <FaqStructuredData faqs={this.state.data} />
                <Tab isLoaded={this.state.isLoaded}>
                    <ExpandableListModule title={this.state.title} description={this.state.description} data={this.state.data} />
                    <div className='row'>
                        <div className='col-12 col-lg-8 offset-lg-2 text-center' style={{ paddingBottom: '100px' }}>
                            <BannerNetworkIssue />
                        </div>
                    </div>
                </Tab>
            </React.Fragment>
        )
    }
}

export default NbnAboutSpeeds



// WEBPACK FOOTER //
// ./resources/js/nbn/NbnAboutSpeeds.js